import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import { UiView, UiViewContent } from '../../../library/layout/Index';
import InvPaymentListRow from './InvPaymentListRow';
import SarasTrans from '../../../library/notifications/SarasTrans';

const InvPaymentList = (props) => {
    const { formObject, viewData, ...restProps } = props;

    console.log("payment list", formObject);
    
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Close" } }}
            formStyle={{ height: '350px' }}
            contentStyle={{ height: '250px', width: "360px" }}
            formTitle={<FormTitle formObject={formObject} value='Payment List' />}
            formObject={formObject} >
            <UiView> 
                <UiViewContent>
                    <ul className="uiListTable" style={{backgroundColor:"#FFF", width:"max-content"}}>
                        <li className="uiSearchHeading">
                            <ul>
                                {/* <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li> */}
                                <li className="uiColumnCenter uiColumn130 "><SarasTrans value="Voucher Code" /></li>
                                <li className="uiColumnCenter uiColumn100 "><SarasTrans value="Voucher Date" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Amount" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                                <InvPaymentListRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={++index} />
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(InvPaymentList, "invPaymentList")